import readFileSync from "~/pages/sandbox/Helpers/ReadFileSync";

const getImageFromFile = (file) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const imageContent = await readFileSync(file);

    const image = new Image();

    image.src = imageContent;

    image.onload = function() {
      resolve(image);
    };

    image.onerror = reject;
  })
}

export default getImageFromFile;
